<template>
    <div class="container">
            <AnnouncementStrip
      message="We've redesigned analytics to be faster, cleaner, and easier to use."
      cta-label="Use New Dashboard"
      cta-url="/analytics/beta"
      dismiss-key="hide_beta_promo"
      @onTryNew="handleTryNew"
      @dismissed="onStripDismissed"
    />
        <div class="text-left pb-2 mt-5">
                    <h3 class="text-primary">Dashboard</h3>
                    <p>Report for: {{reportDate}}</p>
                </div>
        <div class="row py-3">
            <div class="col-sm-12 col-md-6">
                <div>

                    <select v-model="dayOfWeek" class="form-control">
                        <option value="null" >Filter by day of week</option>
                        <option value="monday">Monday</option>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                    </select>
                    <p>You know you can also see perfomance of your business per day?</p>
                    <small class="text-danger">Please note for this you have to select a date range</small>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker"
                    :ranges="false">
                    <template #input="picker" style="width: 100% !important;">
                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(dateRange.startDate) }}
                            - {{ FormatDate(picker.endDate) }}</p>
                        <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
                    </template>
                </date-range-picker>

            </div>
        </div>
        <hr />

        <div class="text-right py-2">

                       <div v-if="isEnterprise" class="dropdown">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                    Actions
                </button>
                <div class="dropdown-menu">
                 <a  class="dropdown-item" href="/tax-ledgers">Tax Ledgers</a>

                    <a  class="dropdown-item" @click="downloadAccountReport('salestax')">Download Sales Tax Ledger</a>
                    <a  class="dropdown-item" @click="downloadAccountReport('pnl')">Download Profit and Loss</a>
                    <a  class="dropdown-item" @click="downloadAccountReport('generalledger')">Download General Ledger</a>
                    <a  class="dropdown-item" @click="generateSalesSummaryReport()">Download Sales Report</a>
                    <a @click="showConsentToDownloadFresh()" class="dropdown-item">Download Full Report <i class="bi bi-download"></i></a>


                </div>
                </div>
                 <a v-else  @click="showConsentToDownloadFresh()" class="btn btn-outline-secondary">Download Report <i class="bi bi-download"></i></a>

            </div>


        <div v-if="hasLoaded===true" class="card">
            <div class="card-body">
                <div class="row">
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-graph-up"></i> Sales</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ convertCurrencyToShillings(Number(todaySales || 0) + Number(invoiceSales || 0)) }}</h5>
                        <hr class="m-0 mb-2 mt-1" />
                        <template v-if="invoiceSales > 0">
                            <p class="text-dark">POS sales - {{ convertCurrencyToShillings(todaySales) }}</p>
                            <p class="text-dark"><a href="/invoices" class="text-dark">Invoices ({{ invoiceCount }}) - {{ convertCurrencyToShillings(invoiceSales) }}</a></p>
                        </template>
                        <p class="text-dark" v-if="todayPaid > 0" >Paid - {{ convertCurrencyToShillings(todayPaid) }}</p>
                        <p class="text-danger" v-if="todayBalances > 0" ><a :href='"/orders?has-balance=1&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' class="text-danger">Balances - {{ convertCurrencyToShillings(todayBalances) }}</a></p>
                        <p class="text-danger" v-if="todayDiscounts > 0" ><a :href='"/orders?has-discount=1&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' class="text-danger">Discounts - {{ convertCurrencyToShillings(todayDiscounts) }}</a></p>
                        <p class="text-danger" v-if="todayPendingOrders > 0" ><a :href='"/orders?un-attended=1&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' class="text-danger">Pending ({{ todayPendingOrders }}) - {{ convertCurrencyToShillings(todayPendingOrdersValue) }}</a></p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-cash-coin"></i> Profits and Losses</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">
                            P&L
                            <span v-if="(todayProfits - todayExpenses - totalWastesSum) > 0" class="text-success">{{ convertCurrencyToShillings(todayProfits - todayExpenses - totalWastesSum) }}</span>
                            <span v-else class="text-danger">({{ convertCurrencyToShillings(todayProfits - todayExpenses - totalWastesSum) }})</span>
                        </h5>
                        <hr class="m-0 mb-2 mt-1" />
                        <p class="text-dark" >Gross Profit - {{ convertCurrencyToShillings(todayProfits) }}</p>
                        <p class="text-dark" v-if="docCounts.invoice_profit"><small>POS {{ convertCurrencyToShillings(docCounts.pos_profits) }} · Invoices {{ convertCurrencyToShillings(docCounts.invoice_profit) }}</small></p>
                        <p class="text-muted" v-if="docCounts.invoice_lines_without_cost > 0"><small>{{ docCounts.invoice_lines_without_cost }} invoiced line(s) have no buying price, so their profit isn't counted</small></p>


                        <div v-for="(method,key) in expenseandPaymentsDifference">

                        <p class="text-dark pt-1">{{ key }}:
                            <small>{{ convertCurrencyToShillings(method) }}</small></p>


                        </div>


                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-credit-card"></i> Payment Methods</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />
                        <div v-if="Object.keys(paymentmethods).length">
                            <h5 class="text-dark" style="font-size: 18px; font-weight: 400;" >Received - {{ convertCurrencyToShillings(totalAmountReceived) }}</h5>
                            <hr class="m-0 mb-2 mt-1" />
                            <div v-if="key" v-for="(method,key) in paymentmethods">

                                <p class="text-dark pt-1">{{ key }}:
                                    <small>{{ convertCurrencyToShillings(method) }}</small></p>


                            </div>
                            <template v-if="enableOpeningCash && openingCashFloat > 0">
                                <hr class="m-0 mb-1 mt-2" />
                                <p class="text-dark pt-1">Opening Float:
                                    <small>{{ convertCurrencyToShillings(openingCashFloat) }}</small>
                                </p>
                                <p class="text-dark pt-1" v-if="cashPaymentAmount > 0">
                                    Expected in Drawer:
                                    <small class="font-weight-bold">{{ convertCurrencyToShillings(expectedCashInDrawer) }}</small>
                                </p>
                            </template>
                            <a v-b-modal="'all-transactions-modal'" href="#" >View All Transactions</a>
                        </div>
                        <div v-if="bnplOutstanding > 0 || bnplOutstandingForPeriod > 0" >

                    <div class="text-dark pb-3">
                         <hr class="m-0 mb-2 mt-1" />
                        <p><i class="bi bi-clock-history"></i> Buy Now Pay Later</p>

                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">
                            <a :href='"/orders?bnpl=1&start-date=" + selectedStartDate + "&end-date=" + selectedEndDate' class="text-dark">
                                {{ convertCurrencyToShillings(bnplOutstandingForPeriod) }}
                            </a>
                        </h5>
                        <small class="text-muted">Owed from orders in this period</small>
                        <hr class="m-0 mb-2 mt-1" />
                        <p class="text-dark pt-1">All-time outstanding:
                            <small class="font-weight-bold">{{ convertCurrencyToShillings(bnplOutstanding) }}</small>
                        </p>
                    </div>

            </div>

                        <div v-if="hasDukakitPayAccount" >
                            <p>{{ $platformBrand.name }} Pay Balance - <span class="badge badge-secondary py-1 px-1">{{ convertCurrencyToShillings(dukakitAccountBalance) }}</span></p>
                            <hr class="m-1"/>
                            <div v-if="dukakitAccountBalance > 100" >
                                <p><a v-b-modal="'withdraw-from-dukapay-modal'" class="btn btn-sm btn-primary">Withdraw/Send to M-pesa</a></p>
                                <hr class="m-1"/>
                                <p> Check Transactions</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-wallet2"></i> Expenses &amp; Wastes</p>
                        <hr class="bg-danger m-0 mb-2 mt-1" />

                        <h5 class="text-danger" style="font-size: 18px; font-weight: 400;">
                            {{ convertCurrencyToShillings(todayTotalExpenses) }}
                        </h5>
                        <hr class="m-0 mb-2 mt-1" />

                        <p v-if="todayExpenses > 0" class="text-danger pt-1" style="font-weight: 400;">
                            From business cash: {{ convertCurrencyToShillings(todayExpenses) }}
                        </p>
                        <p v-if="todayNonDeductibleExpenses > 0" class="text-muted pt-1" style="font-weight: 400;">
                            Monthly / External: {{ convertCurrencyToShillings(todayNonDeductibleExpenses) }}
                            <small class="d-block" style="font-size:11px;">Not deducted from today's sales</small>
                        </p>

                        <div v-if="expenseByPayments && Object.keys(expenseByPayments).length">
                            <hr class="m-0 mb-2 mt-1" />
                            <p class="text-muted" style="font-size:12px;">By payment method</p>
                            <div v-for="(method,key) in expenseByPayments">
                                <p class="text-danger pt-1" style="font-weight: 400;">{{ key }}:
                                    {{ convertCurrencyToShillings(method) }}</p>
                            </div>
                        </div>

                        <div v-if="totalWastesSum > 0">
                            <hr class="m-0 mb-2 mt-1" />
                            <p>Wastes</p>
                            <p><a class="text-danger" href="/wastes">Values - {{ convertCurrencyToShillings(totalWastesSum) }}</a></p>
                        </div>

                        <div v-if="docCounts.supplier_payments > 0">
                            <hr class="m-0 mb-2 mt-1" />
                            <p><a class="text-dark" href="/purchases">Paid to suppliers - {{ convertCurrencyToShillings(docCounts.supplier_payments) }}</a></p>
                            <small class="text-muted d-block" style="font-size:11px;">Stock bought — not an expense</small>
                            <p v-for="(amount, method) in (docCounts.supplier_payments_by_method || {})" :key="'sp' + method" class="text-dark pt-1" style="font-weight: 400;">{{ method }}: {{ convertCurrencyToShillings(amount) }}</p>
                        </div>

                        <p v-if="todayTotalExpenses === 0 && totalWastesSum === 0" class="text-muted" style="font-size:12px;">
                            No expenses recorded for this period
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-cart-check-fill"></i> Orders</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />
                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ todayorders }}</h5>
                        <a v-if="todayorders > 0" :href='"/orders?start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate'>View All</a>
                        <hr class="m-0 mb-2 mt-1" />
                        <p class="text-dark"><a href="/invoices" class="text-dark">Invoices - {{ docCounts.invoice_count || 0 }}</a></p>
                        <p class="text-dark"><a href="/quotes" class="text-dark">Quotes - {{ docCounts.quote_count || 0 }}</a></p>
                        <p class="text-dark"><a href="/deliveries" class="text-dark">Deliveries - {{ docCounts.deliveries_dispatched || 0 }} dispatched, {{ docCounts.deliveries_delivered || 0 }} delivered</a></p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-box-open"></i>Unique Items Sold</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <div v-if="analysisHasLoaded">
                        <h5  class="text-dark" style="font-size: 18px; font-weight: 400;">{{ inventoryAnalysis.length }}</h5>
                        <a href="#" v-b-modal="'inventory-analyis-modal'" v-if="Object.keys(inventoryAnalysis).length > 0">View Inventory Analysis</a>
                     </div>
                        <div v-else class="text-center">
                        <div class="spinner-grow" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        </div>
                        <p  v-b-modal="'inventory-analyis-modal'" > <a  v-if="Object.keys(todayUniqueItems).length > 0"><small>Opening stock, Sold Stock, Remaining stock etc</small></a></p>

                    </div>
                </div>
            </div>

        </div>
            </div>
        </div>
        <div v-else class="card">
            <div class="card-body">
                <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>




        <!-- Financial Highlights: Receivables / Payables / Invoices, fed by the
             dedicated finance-reports endpoint (kept separate from the legacy
             /api/highlights payload above so it stays lightweight). -->
        <div v-if="financialHighlights" class="pt-4">
            <h4>Financial Highlights</h4>
        </div>
        <div v-if="financialHighlights" class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6 col-md-4 border">
                        <div class="py-2 h-100">
                            <div class="text-dark pb-3">
                                <p><i class="bi bi-arrow-down-circle"></i> Receivables</p>
                                <hr class="bg-dark m-0 mb-2 mt-1" />
                                <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ convertCurrencyToShillings(financialHighlights.receivables.outstanding) }}</h5>
                                <hr class="m-0 mb-2 mt-1" />
                                <p class="text-dark">Overdue - {{ convertCurrencyToShillings(financialHighlights.receivables.overdue) }}</p>
                                <p class="text-dark">30+ days - {{ convertCurrencyToShillings(financialHighlights.receivables.overdue_30_plus) }}</p>
                                <p class="text-danger" v-if="financialHighlights.receivables.overdue_90_plus > 0">90+ days - {{ convertCurrencyToShillings(financialHighlights.receivables.overdue_90_plus) }}</p>
                                <a href="/reports/receivables" class="d-block pt-2">View report &rarr;</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 border">
                        <div class="py-2 h-100">
                            <div class="text-dark pb-3">
                                <p><i class="bi bi-arrow-up-circle"></i> Payables</p>
                                <hr class="bg-dark m-0 mb-2 mt-1" />
                                <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ convertCurrencyToShillings(financialHighlights.payables.outstanding) }}</h5>
                                <hr class="m-0 mb-2 mt-1" />
                                <p class="text-dark">Overdue - {{ convertCurrencyToShillings(financialHighlights.payables.overdue) }}</p>
                                <p class="text-dark">30+ days - {{ convertCurrencyToShillings(financialHighlights.payables.overdue_30_plus) }}</p>
                                <p class="text-danger" v-if="financialHighlights.payables.overdue_90_plus > 0">90+ days - {{ convertCurrencyToShillings(financialHighlights.payables.overdue_90_plus) }}</p>
                                <a href="/reports/payables" class="d-block pt-2">View report &rarr;</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 border">
                        <div class="py-2 h-100">
                            <div class="text-dark pb-3">
                                <p><i class="bi bi-receipt"></i> Invoices</p>
                                <hr class="bg-dark m-0 mb-2 mt-1" />
                                <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ convertCurrencyToShillings(financialHighlights.invoices.invoiced) }}</h5>
                                <hr class="m-0 mb-2 mt-1" />
                                <p class="text-dark">Collected - {{ convertCurrencyToShillings(financialHighlights.invoices.collected) }}</p>
                                <p class="text-dark">Outstanding - {{ convertCurrencyToShillings(financialHighlights.invoices.outstanding) }}</p>
                                <p class="text-danger" v-if="financialHighlights.invoices.overdue_count > 0">{{ financialHighlights.invoices.overdue_count }} overdue</p>
                                <a href="/invoices" class="d-block pt-2">View report &rarr;</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Shift Cash Closings alert — only when shifts are enabled and there are pending closings -->
        <div
            v-if="shiftClosingMetrics.pending_shift_closings > 0"
            class="alert d-flex align-items-center justify-content-between mt-3 mb-0"
            style="background:#fff8e1;border:1px solid #ffe082;border-radius:8px;"
        >
            <div class="d-flex align-items-center" style="gap:10px;">
                <i class="bi bi-hourglass-split text-warning" style="font-size:20px;"></i>
                <div>
                    <strong class="text-dark" style="font-size:14px;">
                        {{ shiftClosingMetrics.pending_shift_closings }} shift closing{{ shiftClosingMetrics.pending_shift_closings !== 1 ? 's' : '' }} awaiting approval
                    </strong>
                    <div class="text-muted" style="font-size:12px;">
                        Today's variance: {{ formatVariance(shiftClosingMetrics.today_cash_variance) }}
                    </div>
                </div>
            </div>
            <a href="/shift-cash-closings" class="btn btn-sm btn-warning text-dark" style="border-radius:6px;font-size:12px;font-weight:500;">
                Review &rarr;
            </a>
        </div>

        <div class="pt-5 pb-2">
            <h4>Sales by Category</h4>
            <small class="text-muted d-block"><i class="bi bi-info-circle"></i> Click a category to see its sales over the given period</small>
            <small v-if="dayOfWeek" class="text-muted">Reflects the full date range, not just {{ dayOfWeek }}s</small>
        </div>

        <div v-if="categoryPerformance.length" class="card mb-3">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-sm table-striped table-hover w-100">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th class="text-right">Products</th>
                                <th class="text-right">Revenue</th>
                                <th class="text-right">% of Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="category in categoryPerformance" :key="category.category_id">
                                <td><a class="text-dark" :href="categoryLink(category)">{{ category.name }}</a></td>
                                <td class="text-right">{{ category.product_count }}</td>
                                <td class="text-right">{{ convertCurrencyToShillings(category.revenue) }}</td>
                                <td class="text-right">{{ category.percent_of_total }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="card mb-3">
            <div class="card-body text-center text-muted">
                No category sales for this period
            </div>
        </div>

        <div class="pt-3 pb-2">
            <h4>Sales Statistics</h4>
        </div>

        <div v-if="hasLoadedGraph===true" class="card">
            <div class="card-body">

                <dashboard-chart :chart-data="chartData" :chart-options="chartOptions"></dashboard-chart>
            </div>
        </div>
        <div v-else class="card">
            <div class="card-body">
                <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="userrole.length >0 && userrole[0] ==='Admin'" class="row mb-5 text-dark">
            <div class="col-md-6 border-right border-primary">
                <div class="py-2">
                    <h2 class="text-bold">Top Performing Employee</h2>
                    <small><i class="bi bi-info-circle"></i>You can click on employees name to see the orders and sum of orders made</small>
                </div>


                <table class="table table-sm table-striped table-hover w-100">
                    <thead>
                        <tr>
                            <td>Employee</td>
                            <td>Total Orders</td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="employee in topemployees">

                            <td>
                                <a :href='"/employees?emp_id=" + employee.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate'>
                                <span class="text-capitalize" v-if="employee.full_name === 'null'">{{ employee.full_name }}</span>
                                    <span class="text-capitalize" v-else>{{ employee.name }}</span>
                                </a>
                            </td>
                            <td>
                                <a :href='"/employees?emp_id=" + employee.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate'>{{ employee.sales }}</a></td>

                        </tr>

                    </tbody>
                </table>


            </div>
            <div class="col-md-6 border-left border-primary">
                <div class="py-2">
                    <h2 class="text-bold">Top 10 Selling Items</h2>
                    <small><i class="bi bi-info-circle"></i>You can click on item to see the item activity over the given period</small>


                </div>

                <table class="table table-sm table-striped table-hover w-100">

                    <tbody>
                        <tr v-for="([key, value],index) in limitedItems" >
                            <td> <a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.quantity}}</a></td>

                        </tr>

                    </tbody>
                </table>
                <a v-b-modal="'all-items-sold-modal'" href="#">Show All Items and Qty</a>

            </div>
        </div>
        <div v-if="userrole.length >0 && userrole[0] !=='Admin'" class="row mb-5 text-dark">

            <div class="col-md-12 border-left border-primary">
                <div class="py-2">
                    <h2 class="text-bold">Top 10 Selling Items</h2>
                    <small>Services</small>
                    <small><i class="bi bi-info-circle"></i>You can click on item to see the item activity over the given period</small>

                </div>

                <table class="table table-sm table-striped table-hover w-100">

                    <tbody>
                        <tr v-for="([key, value],index) in limitedItems" >
                            <td> <a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.quantity}}</a></td>

                        </tr>

                    </tbody>
                </table>
                <a v-b-modal="'all-items-sold-modal'" href="#">Show All Items and Qty</a>


            </div>
        </div>
        <hr />
        <b-modal size="lg" id="all-items-sold-modal" hide-footer>
            <div class="text-center">
                <h5 v-if="selectedStartDate !=='' && selectedEndDate !==''">All Items and Quanties Sold on {{ selectedStartDate }} - {{ selectedEndDate }}</h5>
                <h5 v-else>All Items and Quanties Sold</h5>
                <hr />


                 </div>
            <table class="table table-striped">
                <thead>

                    <td>Item</td>
                    <td>Quanties Sold</td>

                </thead>
                <tbody>
                    <tr v-for="(key, value) in topitems" >
                            <!-- <td>{{ index + 1 }}</td> -->
                            <td> <a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + key.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ key.title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + key.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ key.quantity}}</a></td>



                        </tr>
                </tbody>
            </table>

        </b-modal>
        <b-modal size="lg" id="inventory-analyis-modal" hide-footer>
            <div class="text-center">
                <h5>Inventory and Stock Analysis</h5>
                <hr />
                <div class="text-right my-1">
                    <a class="btn btn-outline-secondary" @click="downloadInventoryAnalysis">Download Stock Analysis <i class="bi bi-download"></i></a>

                </div>

                 </div>
            <table class="table table-striped table-responsive">
                <thead>
                    <td>#</td>
                    <td>Item</td>
                    <td>Opening Stock</td>
                    <td>Remaining</td>
                    <td>Restock Count</td>
                    <td>Sold Qty</td>
                </thead>
                <tbody>
                    <tr v-for="(inventory,key) in inventoryAnalysis">
                    <td>{{ key + 1 }}</td>
                    <td>{{ inventory.product.product }}</td>
                    <td>{{ inventory.opening_stock_balance }}</td>
                    <td>{{ inventory.product.remaining_units }}</td>
                    <td>{{ inventory.restock_count }}</td>
                    <td>{{ inventory.sold_qty }}</td>
                    <td></td>
                    </tr>
                </tbody>
            </table>

        </b-modal>
        <b-modal size="lg" id="all-transactions-modal" hide-footer>
            <div class="text-center">
                <h5>Transactions -  {{ convertCurrencyToShillings(totalAmountReceived) }}</h5>
                        <hr class="m-0 mb-2 mt-1" />
                        <div v-if="key" v-for="(method,key) in paymentmethods">

                            <p class="text-dark pt-1">{{ key }}:
                                <small>{{ convertCurrencyToShillings(method) }}</small></p>


                        </div>

                 </div>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Order</th>
                        <th>Amount</th>
                        <th>Mode</th>
                        <th>Order Date</th>
                        <th>Payment Date</th>
                    </tr>

                </thead>
                <tbody>
                    <tr v-if="trx" v-for="(trx,key) in allTransactions">
                    <td>{{ key + 1 }}</td>
                    <td>
                        <a v-if="trx.invoice_id" title="View invoice" :href="'/invoices/' + trx.invoice_id">{{ trx.order }}</a>
                        <a v-else title="View order" :href="'/orders?order-number=' + trx.order + '&source=/dashboard'">{{ trx.order }}</a>
                    </td>
                    <td>{{ convertCurrencyToShillings(trx.amount) }}</td>
                    <td>{{ trx.paymentMethod }}</td>
                    <td>{{ trx.order_date }}</td>
                    <td>{{ trx.trx_date }}</td>
                    <td></td>
                    </tr>
                </tbody>
            </table>
        </div>

        </b-modal>
        <b-modal id="withdraw-from-dukapay-modal" hide-footer>
            <div class="text-center" v-if="!withdrawal.messageToWithdraw">
            <h4>Send to M-pesa</h4>

            <p>The amount will be sent to M-pesa number</p>
            <hr />
            <form @submit.prevent="withdrawToMpesa">
                <div class="form-group">
                    <vue-tel-input :placeholder="712345678" v-model="withdrawal.phone"></vue-tel-input>

                </div>
                <div class="form-group">
                    <input class="form-control" type="number" placeholder="Enter amount" v-model="withdrawal.amount" />

                </div>
                <div class="form-group">
                    <p class="text-left">Reason </p>
                    <textarea class="form-control"v-model="withdrawal.reason"></textarea>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary">Continue to Withdraw</button>

                </div>

            </form>
        </div>
        <div class="text-center" v-else>
            <p><span class="h2"><i class="bi bi-check2-circle"></i></span></p>
            <p class="py-3" v-html="withdrawal.messageToWithdraw"></p>
        </div>
        </b-modal>


    </div>

</template>

<script>
import { downloadFile } from '../../services/pdfDownload';
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import DashboardChart from "../analytics/charts/dashboardsales.vue";

    import {mapGetters} from 'vuex';
import AnnouncementStrip from "../Admin/AnnouncementStrip.vue";
import { recordVisit, setPreferredDashboard } from "../../services/dashboardPreference";
    export default {
        name: "sales",
        components: {
            DateRangePicker,
            DashboardChart,
            AnnouncementStrip
        },
        props: ['userrole'],
        data() {
            return {
                financialHighlights: null,
                paymentmethods: '',
                todaySales: 0,
                invoiceSales: 0,
                invoiceCount: 0,
                docCounts: {},
                todayPaid: 0,
                todayBalances: 0,
                todayDiscounts : 0,
                todayPendingOrders : 0,
                todayPendingOrdersValue : 0,
                todayExpenses: 0,
                todayTotalExpenses: 0,
                todayNonDeductibleExpenses: 0,
                todayProfits: '',
                todayorders: '',
                todayUniqueItems: '',
                categoryPerformance: [],
                expenseByPayments:'',
                expenseandPaymentsDifference:'',
                topitems: [],
                topemployees: '',
                totalAmountReceived: '',
                allTransactions: '',
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                chartData: {
                    labels: [],
                    datasets: []
                },
                dayOfWeek:null,
                chartOptions: {
                    responsive: true
                },
                graphData: {
                    sales: [],
                    timeofday: []
                },
                autoApply: true,
                inventoryAnalysis:{},
                hasLoaded:false,
                hasLoadedGraph:false,
                analysisHasLoaded:false,
                totalWastesSum:0,
                selectedStartDate:'',
                selectedEndDate:'',
                openingCashFloat: 0,
                enableOpeningCash: false,
                shiftClosingMetrics: {
                    pending_shift_closings: 0,
                    approved_closings_today: 0,
                    today_cash_variance: 0,
                    month_cash_variance: 0
                },
                bnplOutstanding: 0,
                bnplOutstandingForPeriod: 0,
                dukakitAccountBalance:0,
                hasDukakitPayAccount:true,
                newReport:0,
                withdrawal:{
                    amount:'',
                    phone:'',
                    messageToWithdraw:false,
                    reason:'',
                }
            }
        },
        computed: {
            ...mapGetters(['userDetails']),

                limitedItems() {

                    const itemsArray = Object.entries(this.topitems);

                    return itemsArray.slice(0, 10);

                },
                 reportDate() {
                    const urlParams = new URLSearchParams(window.location.search);
                    const daySelected = urlParams.get('day-of-week') || "Today";
                    const startDate = urlParams.get('start-date');
                    const endDate = urlParams.get('end-date');
                    let selectedDate;

                    if (startDate && endDate) {
                        const formattedStartDate = new Date(startDate).toLocaleDateString('en-US');
                        const formattedEndDate = new Date(endDate).toLocaleDateString('en-US');
                        selectedDate = `${formattedStartDate} To ${formattedEndDate}`;
                    } else {
                        const today = new Date().toLocaleDateString('en-US');
                        selectedDate = `Today - ${today}`;
                    }

                    if (daySelected === "Today") {
                        return selectedDate;
                    }

                    return `${selectedDate}, focusing on ${daySelected.charAt(0).toUpperCase() + daySelected.slice(1)}s`;
                },
            isEnterprise() {
            return (
                (this.userDetails?.company?.subscription_plan ?? 0) > 2000
            );
            },

            cashPaymentAmount() {
                if (!this.paymentmethods || typeof this.paymentmethods !== 'object') return 0;
                const key = Object.keys(this.paymentmethods).find(k => k.toLowerCase().includes('cash'));
                return key ? (this.paymentmethods[key] || 0) : 0;
            },

            expectedCashInDrawer() {
                return this.openingCashFloat + this.cashPaymentAmount;
            },
        },
        watch: {

         dateRange: {
             deep: true,
             handler(after, before) {
                 const urlParams = new URLSearchParams(window.location.search);
                 if (after.startDate && after.endDate) {

                     const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                     const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                     urlParams.set('start-date', startDateString);
                     urlParams.set('end-date', endDateString);
                     this.selectedStartDate = startDateString
                     this.selectedEndDate = endDateString


                  }
                  window.history.replaceState(null, null, '?' + urlParams.toString());

                 this.getHighlights()
                 this.displayData()
                 this.getInventoryAnalysis()
                 this.getCategoryPerformance()
                 }
             },
             dayOfWeek: {
    handler(after) {
        const urlParams = new URLSearchParams(window.location.search);

        if (after) {
            // Set the day-of-week in the URL
            urlParams.set('day-of-week', after);

            // Check if start-date and end-date are not set
            if (!urlParams.get('start-date') || !urlParams.get('end-date')) {
                const today = new Date();
                const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

                // Format dates as MM/DD/YYYY
                const formattedStartDate = startOfMonth.toLocaleDateString('en-US');
                const formattedEndDate = today.toLocaleDateString('en-US');

                // Update URL parameters
                urlParams.set('start-date', formattedStartDate);
                urlParams.set('end-date', formattedEndDate);

                // Update the local dateRange data
                this.$set(this.dateRange, 'startDate', startOfMonth);
                this.$set(this.dateRange, 'endDate', today);
            }
        } else {
            // Remove day-of-week if it's cleared
            urlParams.delete('day-of-week');
        }

        // Update the URL without reloading the page
        window.history.replaceState(null, null, '?' + urlParams.toString());

        // Trigger relevant data updates
        this.getHighlights();
        this.displayData();
        this.getInventoryAnalysis();
        this.getCategoryPerformance();
    },
},


     },
        methods: {
            handleTryNew() {
                setPreferredDashboard('beta');
            },
            onStripDismissed() {},
            withdrawToMpesa() {
                axios.post('/api/dukakit-account/withdraw', {...this.withdrawal}).then(results=>{
                    if(results.status === 200 && results.data.type === 'success')
                    {
                        this.$toasts.push(
                                {
                                    'type':'success',
                                    'message':'Your request has been received and being processed. You will receive notification',
                                }
                            )
                            this.withdrawal.messageToWithdraw = "Your request is being processed"

                        setTimeout(() => {

                            window.location.href='/dashboard'
                        }, 6000);

                    }

                })
            },
            showConsentToDownloadFresh() {
                    this.boxTwo = ''
                    this.$bvModal.msgBoxConfirm('To avoid duplication and save time, we automatically back up your report the first time it is downloaded for the specified period. If you`d like a refreshed version, please click below to generate a new report.', {
                    title: 'Generate report',
                    size: 'lg',
                    buttonSize: 'md',
                    okVariant: 'danger',
                    okTitle: 'Download Report',
                    cancelTitle: 'Generate New Report',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                    })
                    .then(value => {
                        if(value === false)
                        {
                            this.newReport = 1
                        }
                        else
                        {
                            this.newReport = 0
                        }
                        this.downloadReport()
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
    generateSalesSummaryReport() {
       const urlParams = new URLSearchParams(window.location.search);


        axios.post('/api/sales-analytics/reports/retail/generate', {
          report_type: 'sales_summary',
          format: 'pdf',
          filters: {
          start_date:  urlParams.get('start-date'),
            end_date: urlParams.get('end-date'),
            branch_id: '',
            cashier_id: ''
          },

        }).then(response => {
                        if(response.status === 200)
                        {

          downloadFile(response.data.report_url || response.data.download_url, response.data.filename || 'sales-summary.pdf');
          setTimeout(() => this.$emit('close'), 1500);
                        }}).catch (err=>{
         console.log("-------" + err.response?.data?.message || 'Failed to generate report');
      } )
    },

    downloadAccountReport(type) {
        const urlParams = new URLSearchParams(window.location.search);
        const endpoints = {
            pnl: '/api/sales-analytics/reports/retail/profit-loss/download',
            salestax: '/api/sales-analytics/reports/retail/sales-tax/download',
            generalledger: '/api/sales-analytics/reports/retail/general-ledger/download',
        };

        const payload = {
            start_date: urlParams.get('start-date'), // or hardcode if needed
            end_date: urlParams.get('end-date'),
            format: 'pdf',
        };

        const url = endpoints[type];
        if (!url) {
            console.error('Unknown report type:', type);
            return;
        }

        axios.post(url, payload)
            .then(res => {
                if (res.data && res.data.success) {
                    this.triggerDownload(res.data.data);
                } else {
                    this.$bvToast?.toast('Failed to generate report', {
                        variant: 'danger',
                        solid: true,
                    });
                }
            })
            .catch(err => {
                console.error(err);
                this.$bvToast?.toast('Report download failed', {
                    variant: 'danger',
                    solid: true,
                });
            });
    },

    triggerDownload(file) {
        return downloadFile(file.url || file.download_url || file.report_url, file.filename || 'report.pdf');
    },


            async downloadReport()
            {
                const urlParams = new URLSearchParams(window.location.search);
                await axios.get('/api/reports-daily', {
                        params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),
                            from_dashboard:true,
                            new_report: this.newReport,
                        },
                        // responseType: 'blob'
                    })
                    .then(response => {
                        if(response.status === 200)
                        {
                            // const url = window.URL.createObjectURL(new Blob([response.data]));
                            // const link = document.createElement('a');
                            // const fileName = moment().format('HMY-is');
                            // link.href = url;
                            // link.setAttribute('download', 'Report-' + fileName +'.pdf');
                            // document.body.appendChild(link);
                            // link.click();
                            this.$bvModal.msgBoxConfirm('We will send you the report on your email - '+ this.userDetails.email , {
                                title: 'Report Request received',
                                size: 'md',
                                buttonSize: 'md',
                                okVariant: 'success',
                                okTitle: 'Ok Waiting!',
                                cancelTitle: 'Close',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                                })
                                .then(value => {

                                })
                                .catch(err => {

                                })

                        }
                        else{
                            this.$toasts.push(
                                {
                                    'type':'error',
                                    'message':' There was an error CODE - ' + response.status,
                                }
                            )
                        }

                    })
                    .catch(error => {

                    });
            },
            displayData() {
                // let uri = 'api/analytics/sales';
                let Sales = [];
                let Timeofday = [];
                this.hasLoadedGraph = false
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/analytics-sales', {
                    params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),


                        }
                    })
                    .then(result => {
                        $.each(result.data, function(key, value) {
                            Timeofday.push(key);
                            Sales.push(value)
                        });
                        this.chartData = {
                            labels: Timeofday,
                            datasets: [{
                                label: 'Data as from ' + this.FormatDate((this.dateRange.startDate === null) ? ((this.selectedStartDate ==='') ? moment() : this.selectedStartDate) : this.dateRange.startDate ) + ' to ' +
                                    this.FormatDate((this.dateRange.endDate === null) ?  ((this.selectedEndDate ==='') ? moment() : this.selectedEndDate) : this.dateRange.endDate),
                                backgroundColor: '#fd4719',
                                data: Sales
                            }]
                        }
                        this.hasLoadedGraph = true
                    }).catch(error => {
                        // what now?
                    })
            },
            getDukakitPayAccountBalance() {
                axios.get('/api/dukakit-account/balance')
                    .then(results => {
                        if (results.status === 200) {
                            this.dukakitAccountBalance = results.data;
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 433) {
                            this.hasDukakitPayAccount = false;
                        } else {

                        }
                    });
            },

            getInventoryAnalysis() {
                this.analysisHasLoaded = false;
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/inventory-analysis', {
                    params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),

                        }
                    })
                    .then(result => {
                        this.inventoryAnalysis = result.data
                        this.analysisHasLoaded = true
                    }).catch()
                },
            getHighlights() {

                this.hasLoaded = false
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/highlights', {
                        params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),

                        }
                    })
                    .then(result => {
                        if (result.status === 200) {
                            this.todayExpenses = result.data.expenses;
                            this.todayTotalExpenses = result.data.total_expenses || result.data.expenses || 0;
                            this.todayNonDeductibleExpenses = result.data.non_deductible_expenses || 0;
                            this.todayorders = result.data.orders;
                            this.todayUniqueItems = result.data.uniqueItems;
                            this.paymentmethods = result.data.payments;
                            this.topemployees = result.data.employees;
                            this.topitems = result.data.items;
                            this.todaySales = result.data.sales;
                            this.invoiceSales = result.data.invoice_sales || 0;
                            this.invoiceCount = result.data.invoice_count || 0;
                            this.docCounts = result.data;
                            this.todayBalances = result.data.balances;
                            this.todayPaid = result.data.paid;
                            this.todayProfits = result.data.profits;
                            this.todayDiscounts = result.data.discounts;
                            this.todayPendingOrders = result.data.pending;
                            this.todayPendingOrdersValue = result.data.pendingValue;
                            this.expenseByPayments = result.data.expensePayments;
                            this.expenseandPaymentsDifference = result.data.expenseandPaymentsDifference;
                            this.totalAmountReceived = result.data.totalAmountReceived;
                            this.allTransactions = result.data.allTransactions;
                            this.totalWastesSum = result.data.wastes;
                            this.openingCashFloat = result.data.opening_cash_float || 0;
                            this.enableOpeningCash = result.data.enable_opening_cash || false;
                            this.bnplOutstanding = result.data.bnplOutstanding || 0;
                            this.bnplOutstandingForPeriod = result.data.bnplOutstandingForPeriod || 0;
                        }
                        this.hasLoaded = true;
                    }).catch(err => {

                    })
            },
            getFinancialHighlights() {
                axios.get('/api/reports/finance/highlights').then(res => {
                    this.financialHighlights = res.data;
                }).catch(() => {
                    // Non-critical strip; the rest of the dashboard still works without it.
                });
            },
            getCategoryPerformance() {
                // Uses the dedicated lightweight endpoint rather than
                // /executive-summary - that one recomputes ~12 heavy
                // aggregations (sales, payments, tax, inventory, COGS, etc.)
                // just to read this one field, which was overloading MySQL's
                // connection pool on every dashboard load/filter change.
                const urlParams = new URLSearchParams(window.location.search);
                const today = moment().format('YYYY-MM-DD');
                axios.get('/api/sales-analytics/metrics/categories', {
                        params: {
                            start_date: urlParams.get('start-date') || today,
                            end_date: urlParams.get('end-date') || today,
                        }
                    })
                    .then(result => {
                        this.categoryPerformance = result.data || [];
                    }).catch(() => {});
            },
            fetchShiftClosingMetrics() {
                axios.get('/api/shift-cash-closings/metrics')
                    .then(res => { this.shiftClosingMetrics = res.data; })
                    .catch(() => {});
            },

            formatVariance(value) {
                if (!value) return 'KES 0.00';
                const abs = Math.abs(value);
                const formatted = 'KES ' + abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                return value < 0 ? '-' + formatted : formatted;
            },

            downloadInventoryAnalysis()
            {
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/download-inventory-analysis', {
                    params: {
                        start_date: urlParams.get('start-date'),
                        end_date: urlParams.get('end-date')
                    },
                    responseType: 'blob'
                    })
                    .then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    const fileName = 'Inventory-analysis-' + moment().format('H-I-M-Y') + '.xlsx';
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    })
                    .catch(error => {
                    console.error("Download error:", error);
                    });

            },
            categoryLink(category) {
                const urlParams = new URLSearchParams(window.location.search);
                const today = moment().format('YYYY-MM-DD');
                const start = moment(urlParams.get('start-date') || today).format('YYYY-MM-DD');
                const end = moment(urlParams.get('end-date') || today).format('YYYY-MM-DD');
                return `/analytics/category-sales?category-id=${category.category_id}&start-date=${start}&end-date=${end}`;
            },
            FormatDate(date) {
                let finaldate = moment(date).format('DD-MMM-YYYY');
                return finaldate;
            },
        },
        mounted() {
            recordVisit('classic');
            this.getDukakitPayAccountBalance()
            this.getHighlights();
            this.displayData();
            this.getInventoryAnalysis();
            this.getCategoryPerformance();
            this.fetchShiftClosingMetrics();
            this.getFinancialHighlights();
            },

    }
</script>

<style scoped>
    .bg-success-light {
        background: #daf3d9;
    }
    .bg-dark-light {
        background: #e0e0e0;
    }
    .bg-danger-light {
        background: #efdcdb;
    }
    .bg-primary-light {
        background: #badaf5;
    }
</style>
